<template>
	<div class="nav-main">
		<div class="main-nav">

			<div class="row al-c" style="justify-content: space-between;">
				<img src="../../assets/img/logo-b.png" style="height: 44px;" />
				<div class="item-no" style="justify-content:flex-end">
					<el-menu style="height: 60px;width: 100%;" :default-active="activeIndex" class="el-menu-demo"
						mode="horizontal">
						<el-menu-item index="1" @click="route('index')"><span class="nav-text"
								:class="{ 'nav-dt': scrollTop > 0 }">走进贸宝</span></el-menu-item>
						<!-- <el-menu-item  index="2" @click="route('cpzx')"><span class="nav-text" :class="{'nav-dt':scrollTop>0}">产品中心</span></span></el-menu-item>	 -->

						<el-submenu index="2">
							<template slot="title">
								<span class="nav-text" :class="{ 'nav-dt': scrollTop > 0 }">产品方案</span>
							</template>
							<!-- 新增的三个子选项 -->
							<el-menu-item index="2-1" @click="route('whzlDetail')">智慧燃气解决方案</el-menu-item>
							<el-menu-item index="2-2" @click="route('xjxjDetail')">智慧水务解决方案</el-menu-item>
							<el-menu-item index="2-3" @click="route('xwDetail')">智慧工厂解决方案</el-menu-item>
						</el-submenu>
						<el-menu-item index="3" @click="route('gywm')"><span class="nav-text"
								:class="{ 'nav-dt': scrollTop > 0 }">客户案例</span></el-menu-item>
						<!-- <el-menu-item  index="4" @click="route('lcfw')"><span class="nav-text" :class="{'nav-dt':scrollTop>0}">流程服务</span></el-menu-item> -->
						<el-menu-item index="5" @click="route('khal')"><span class="nav-text"
								:class="{ 'nav-dt': scrollTop > 0 }">技术服务</span></el-menu-item>
						<el-menu-item index="6" @click="route('xwzx')"><span class="nav-text"
								:class="{ 'nav-dt': scrollTop > 0 }">关于我们</span></el-menu-item>
						<el-menu-item index="7" @click="route('lianxi')"><span class="nav-text"
								:class="{ 'nav-dt': scrollTop > 0 }">联系我们</span></el-menu-item>
					</el-menu>
				</div>
				<!-- <div class="item-no" style="margin-left: 10px;">
					<el-input placeholder="搜索" suffix-icon="el-icon-search" style="width: 255px;height: 40px;" ></el-input>
				</div> -->
			</div>
			<!-- <div style="position: fixed;bottom: 20px;right: 20px;z-index: 9999;cursor: pointer;">
				<img src="../../assets/img/floatImg.png" @click="route('contact')" />
			</div> -->
		</div>
		<!--<div style="background: #f7f7f7;position: fixed;top:30px;left: 320px;padding: 20px;">
			详情请拨打电话:021-63366996
		</div>-->
	</div>
</template>

<script>
export default {
	name: "App",

	data() {
		return {
			modal5: false,
			langCn: "",
			langEn: "",
			productName: "",
			activeIndex: '',
			searchName: '',
			scrollTop: 0,
			centerDialogVisible: false,
			lan: 'EN',
			type: '1'
		};
	},
	created() {
		if (this.$route.meta.name) {
			// debugger
			this.activeIndex = this.$route.meta.name;
		}
	},
	methods: {
		route(name) {
			window.scrollTo(0, 0);
			this.$router.push(name);
		},
		handleScroll() {
			this.scrollTop = document.body.scrollTop || document.documentElement.scrollTop;

			// console.log(scrollTop);
		}

	},
	mounted() {
		window.addEventListener('scroll', this.handleScroll, true)
	},
};
</script>

<style scoped>
.nav-main {
	display: flex;
	top: 0;
	left: 0;
	width: 100%;
	height: 80px;
	position: fixed;
	flex-direction: column;
	z-index: 1002;
	background: #ffffffed;
	/*box-shadow: 0px 2px 5px 0px rgba(116, 116, 116, 0.3);*/
	box-shadow: 0px 0px 7px 0px rgba(127, 127, 127, 0.14);
}

.nav-down {
	background: #5b5b5b !important
}



.main-nav {
	width: 1200px;
	margin: auto;
}

.nav-title {
	display: flex;
}

.el-menu {
	background: none !important;
}

.el-menu.el-menu--horizontal {
	border-bottom: none;
}

.el-menu--horizontal>.el-menu-item.is-active span {
	border-bottom: none !important;
	font-size: 18px;
	color: #f29a22;
}






.el-menu--horizontal>.el-menu-item {
	font-size: 18px;
	color: #696969;
	border-bottom: none !important;
}

/* .nav-text{
		font-size: 18px;
		color: #fff;
		background:none;
	} */
/* .nav-dt {
	font-size: 18px;
	color: #000;
	background: none;
	font-weight: 400;
} */





.el-menu--horizontal>.el-menu-item {
	/* line-height: 80px; */
	margin-left: 55px;
}

.el-menu-item {
	padding: 0;

}

.el-menu--horizontal>.el-menu-item:not(.is-disabled):focus,
.el-menu--horizontal>.el-menu-item:not(.is-disabled):hover,
.el-menu--horizontal>.el-submenu .el-submenu__title:hover {
	background: none !important;
}

.el-menu--horizontal .el-menu-item:not(.is-disabled):focus,
.el-menu--horizontal .el-menu-item:not(.is-disabled):hover span {
	color: #f29a22;
	background: none !important;
}

/deep/.el-input__inner {
	height: 40px !important;
	width: 100% !important;
	border: 1px solid #BFBFBF;
	border-radius: 4px !important;
}

/deep/.el-input__icon {
	line-height: 40px !important;
}

.lan-box {
	width: 47px;
	height: 47px;
	justify-content: center;
	align-items: center;
	border: 2px solid #C7FF00;
}
/deep/.el-submenu__title{
	padding: 0px!important;
	margin-left: 60px;
	font-size: 14px!Important;
	color: #696969!important;
}
</style>